import { Color } from "../../helpers";
import { ZoningLabel } from "../../types";
import { State } from "../state";

export interface ChangeLabelColorAction {
  labelKey: string;
  zoningLabel: ZoningLabel;
  color: any;
  type: "CHANGE LABEL COLOR";
}

export const changeLabelColor = (
  state: State,
  action: ChangeLabelColorAction,
): State => {

  const newTaxi = {
    ...state.taxonomy,
    rawLabels: {
      ...state.taxonomy.rawLabels,
      [action.labelKey]: {
        group: action.zoningLabel.group,
        color: new Color(
          action.color.rgb.r, 
          action.color.rgb.g,
          action.color.rgb.b,
          action.color.rgb.a)
      }
    }
  }

  return {
    ...state,
    taxonomy: newTaxi
  };
};
